module.exports = __webpack_public_path__ + "img/mosquita_create_account.07f9acd3.png";